import React from 'react';
import { Button, Dropdown, Icon } from 'semantic-ui-react';

export const MODEL_COMPACT_KEY_V113 = 'alfredapi.model.compact.v113';
export const catalogPageSizeV113 = (compact) => (compact ? 50 : 40);
export const catalogMetricSortV113 = (sort) =>
  ['usage', 'success', 'latency'].includes(sort);

export function catalogCompactPreferenceV113(storage) {
  try {
    return storage.getItem(MODEL_COMPACT_KEY_V113) !== 'false';
  } catch {
    return true;
  }
}

export function catalogPaginationTextV113(language) {
  return language?.startsWith('zh')
    ? {
        compact: '\u7cbe\u7b80\u6a21\u5f0f',
        page: '\u9875\u7801',
        previous: '\u4e0a\u4e00\u9875',
        next: '\u4e0b\u4e00\u9875',
        size: '\u4e2a / \u9875',
        current: '\uff08\u5f53\u524d\u9875\uff09',
      }
    : {
        compact: 'Compact mode',
        page: 'Page',
        previous: 'Previous page',
        next: 'Next page',
        size: 'per page',
        current: ' (current page)',
      };
}

export function CatalogPaginationV113({ pagination, text, disabled, onChange }) {
  if (!pagination) return null;
  const { page, total_pages: pages, page_size: size } = pagination;
  return (
    <nav className='model-pagination-v113' aria-label={text.page}>
      <span>{size} {text.size}</span>
      <Button basic icon disabled={disabled || page <= 1}
        aria-label={text.previous} title={text.previous} onClick={() => onChange(page - 1)}>
        <Icon name='chevron left' />
      </Button>
      <Dropdown compact selection value={page} disabled={disabled}
        aria-label={text.page}
        options={Array.from({ length: pages }, (_, i) => ({
          key: i + 1, value: i + 1, text: `${i + 1} / ${pages}`,
        }))}
        onChange={(_, { value }) => onChange(value)} />
      <Button basic icon disabled={disabled || page >= pages}
        aria-label={text.next} title={text.next} onClick={() => onChange(page + 1)}>
        <Icon name='chevron right' />
      </Button>
    </nav>
  );
}
